/* eslint-disable camelcase */
import React from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import gql from 'graphql-tag';
import { propType } from 'graphql-anywhere';
import {
  Glyphicon,
  Table,
} from 'react-bootstrap';

// NOTE: stylesheet vs inline?
const rowStyle = {
  cursor: 'pointer',
};

// TODO: Handle null fields. Currently assumes all fields are always available.
const TimeEntryViewer = (props) => {
  const renderRow = (item) => {
    const {
      key,
      pto_type,
      ticket_number,
      equipment,
      date,
      start_time,
      end_time,
      total_hours,
      notes,
    } = item;
    const onSelect = () => { props.onSelect(item); };
    const onDelete = (e) => {
      if (e) {
        e.stopPropagation();
      }
      props.onDelete(item);
    };

    let className = '';
    if (props.selectedItem && key === props.selectedItem.key) {
      className = 'active';
    }

    const ticketNumberValue = ticket_number ? ticket_number.number : 'none';
    const equipmentValue = equipment ? equipment.equipment_number : 'none';

    return (
      // eslint-disable-next-line react/no-unknown-property
      <tr key={key} subject={key} className={className} style={rowStyle} onClick={onSelect}>
        <td>{date}</td>
        <td>{pto_type}</td>
        <td>{ticketNumberValue}</td>
        <td>{equipmentValue}</td>
        <td>{start_time}</td>
        <td>{end_time}</td>
        <td>{total_hours.to_string}</td>
        <td>{notes}</td>
        <td>
          <Glyphicon glyph="remove" onClick={onDelete} />
        </td>
      </tr>
    );
  };

  const { crewTotalHours } = props;

  return (
    <div>
      <Table responsive>
        <thead>
          <tr>
            <th>Date</th>
            <th>PTO Type</th>
            <th>Ticket</th>
            <th>Equipment</th>
            <th>Start Time</th>
            <th>End Time</th>
            <th>Hours</th>
            <th>Notes</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {props.items.map(renderRow, this)}
        </tbody>
      </Table>
      <div className="pull-right">Total Hours: {crewTotalHours}</div>
    </div>
  );
};

TimeEntryViewer.fragments = {
  crewViewer: gql`
    fragment TimeEntryViewer on TimeEntryForm {
      key
      pto_type
      ticket_number {
        number
      }
      equipment {
        equipment_number
      }
      date
      start_time
      end_time
      total_hours {
        to_string
      }
      notes
    }
  `,
};

TimeEntryViewer.propTypes = exact({
  /* eslint-disable react/no-unused-prop-types, react/forbid-prop-types */
  items: PropTypes.arrayOf(propType(TimeEntryViewer.fragments.crewViewer)).isRequired,
  selectedItem: propType(TimeEntryViewer.fragments.crewViewer),
  crewTotalHours: PropTypes.string,
  onSelect: PropTypes.func.isRequired,
  // FIXME: I have *no* clue why this prop shows up as undefined when required ...
  // Leaving unrequired for now
  onDelete: PropTypes.func,
});

TimeEntryViewer.defaultProps = {
  selectedItem: null,
  crewTotalHours: '0',
  /* Adding in default prop to fix eslint issue */
  onDelete: {},
};

export default TimeEntryViewer;
